// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__12oI8","inputDescription":"styles_inputDescription__1EXBB"};